import React from 'react';
import { componentService } from 'js/services/component.service';

export const PlayerYearlyStatistics = React.lazy(() => import(/* webpackChunkName: "player-yearly-statistics" */ './PlayerYearlyStatistics'));

componentService.registerPageComponents({ 'player-yearly-statistics': PlayerYearlyStatistics });
